<template>
    <!-- 详情模块 -->
    <div class="cover-content form-wrapper">
        <div class="ft-box">
            <div class="ft-title aFlex">
                <Icon class="ft-title-mark" type="md-bookmark" />
                <span>人员基本信息</span>
            </div>
            <div class="ft-form-wrapper">
                <div class="ft-form-item">
                    <div class="ft-th">姓名</div>
                    <div class="ft-td ft-bold">{{formData.workerName}}</div>
                </div>
                <div class="ft-form-item">
                    <div class="ft-th">籍贯</div>
                    <div class="ft-td">{{formData.nativePlace}}</div>
                </div>
                <div class="ft-form-item">
                    <div class="ft-th">身份证号</div>
                    <div class="ft-td">{{formData.idCardNumber}}</div>
                </div>
                <div class="ft-form-item">
                    <div class="ft-th">性别</div>
                    <div class="ft-td">{{formData.gender}}</div>
                </div>
                <div class="ft-form-item">
                    <div class="ft-th">年龄</div>
                    <div class="ft-td">{{formData.age}}</div>
                </div>
                <div class="ft-form-item">
                    <div class="ft-th">民族</div>
                    <div class="ft-td">{{formData.nation}}</div>
                </div>
                <div class="ft-form-item">
                    <div class="ft-th">出生日期</div>
                    <div class="ft-td">{{formData.birthday}}</div>
                </div>
                <div class="ft-form-item">
                    <div class="ft-th">住址</div>
                    <div class="ft-td">{{formData.address}}</div>
                </div>
                <div class="ft-form-item">
                    <div class="ft-th">联系电话</div>
                    <div class="ft-td">{{formData.cellPhone}}</div>
                </div>
                <div class="ft-form-item">
                    <div class="ft-th">政治面貌</div>
                    <div class="ft-td">{{formData.politicsType}}</div>
                </div>
                <div class="ft-form-item">
                    <div class="ft-th">文化程度</div>
                    <div class="ft-td">{{formData.cultureLevelType}}</div>
                </div>
                <div class="ft-form-item">
                    <div class="ft-th">紧急联系人</div>
                    <div class="ft-td">{{formData.urgentLinkMan}}</div>
                </div>
                <div class="ft-form-item">
                    <div class="ft-th">紧急联系电话</div>
                    <div class="ft-td">{{formData.urgentLinkManPhone}}</div>
                </div>
            </div>
        </div>
        <div class="ft-box">
            <div class="ft-title aFlex">
                <Icon class="ft-title-mark" type="md-bookmark" />
                <span>从业经历</span>
            </div>
            <Table border size="large"
                   :columns="joinProjectColumns" :data="joinProjects" highlight-row>
                <template slot-scope="{ row, index }" slot="corpName">
                    <span class="ft-bold-blue link-span" @click="handleJump(row.corpId)">{{row.corpName}}</span>
                    <div>{{row.corpCode}}</div>
                </template>
                <template slot-scope="{ row, index }" slot="projectName">
                    <span class="ft-bold-blue">{{row.projectName}}</span>
                </template>
                <template slot-scope="{ row, index }" slot="workInDate">
                    <div>进：{{row.workInDate}}</div>
                    <div>退：{{row.workOutDate}}</div>
                </template>
            </Table>
        </div>
        <div class="ft-box">
            <div class="ft-title aFlex">
                <Icon class="ft-title-mark" type="md-bookmark" />
                <span>教育培训经历</span>
            </div>
            <Table border size="large"
                   :columns="joinTrainColumns" :data="joinTrain" highlight-row>
                <template slot-scope="{ row, index }" slot="projectName">
                    <span class="ft-bold-blue link-span" @click="handleProject(row.projectId)">{{row.projectName}}</span>
                </template>
            </Table>
        </div>
    </div>
</template>
<style >
</style>
<script>
    export default {
        data(){
            return {
                workerId:'',
                formData:{
                    workerName:'',
                    idCardNumber:'',
                    gender:'',
                    age:'',
                    nation:'',
                    birthday:'',
                    address:'',
                    cellPhone:'',
                    politicsType:'',
                    cultureLevelType:'',
                    urgentLinkMan:'',
                    urgentLinkManPhone:'',
                },
                joinProjectColumns:[
                    {
                        title: '企业名称',
                        slot: 'corpName',
                        align:'center',
                        minWidth:100
                    },
                    {
                        title: '参建项目',
                        slot: 'projectName',
                        align:'center'
                    },
                    {
                        title: '工种（岗位）',
                        key: 'workType',
                        align:'center'
                    },
                    {
                        title: '所属班组',
                        key: 'teamName',
                        align:'center'
                    },
                    {
                        title: '进/退场时间',
                        slot: 'workInDate',
                        align:'center'
                    },
                    {
                        title: '劳动合同',
                        key: 'contractsNum',
                        align:'center'
                    }
                ],
                joinProjects:[],
                joinTrainColumns:[
                    {
                        title: '项目名称',
                        slot: 'projectName',
                        align:'center',
                        minWidth:100
                    },
                    {
                        title: '培训名称',
                        key: 'trainingName',
                        align:'center'
                    },
                    {
                        title: '培训人',
                        key: 'trainer',
                        align:'center'
                    },
                    {
                        title: '培训时间',
                        key: 'trainingDate',
                        align:'center'
                    },
                    {
                        title: '培训时长（小时）',
                        key: 'trainingDuration',
                        align:'center'
                    },
                    {
                        title: '培训类型',
                        key: 'trainingType',
                        align:'center'
                    }
                ],
                joinTrain:[],
            };
        },
        computed:{

        },
        //进入路由之前 改变pname
        // beforeRouteEnter(to,from,next){
        //     if(from.name == 'personnelList'){
        //         to.meta.pname = 'personnelList'
        //     }else {
        //         to.meta.pname = 'postList'
        //     }
        //     next();
        // },
        created(){
            this.workerId= this.$route.query.workerId;
            this.getPageData();
        },
        watch: {

        },
        methods: {
            /* 跳转页面 */
            handleJump(corpId){
                this.$router.push({
                    name: 'unitDetail',
                    query: {
                        corpId:corpId
                    }
                });
            },
            /* 跳转项目详情 */
            handleProject(projectId){
                this.$router.push({
                    name: 'projectDetail',
                    query: {
                        projectId:projectId
                    }
                });
            },
            /*取消返回*/
            handleCancel() {
                this.$router.go(-1);
            },
            /*获取页面信息*/
            getPageData(){
                this.axios({
                    method: 'get',
                    url:'/worker/sx/detail',
                    params:{
                        workerId:this.workerId,
                    }
                }).then((response)=>{
                    if(response.data.success){
                        this.formData=response.data.data.workerInfo;
                        this.joinProjects=response.data.data.joinProjects;
                        this.joinTrain=response.data.data.joinTrain;
                    }
                });
            },
        }
    };
</script>
